import React from 'react';
import PropTypes from 'prop-types';
import s from './ModelVariantList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import moment from 'moment-timezone';
import MoreOption from '../WSAControls/MoreOption/MoreOption';

const ModelVariantListTable = ({
  paginatedData = [],
  UpdateAllowed,
  DuplicateAllowed,
  ConfigurationAllowed,
  currentTimezone,
  ModelCategoryId,
  ModelId,
  IsModelCategoryOwner
}) => {
  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="modelVariant.version" defaultMessage="Variant" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="modelVariant.description" defaultMessage="Description" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="modelVariant.dateCreated" defaultMessage="Date created" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="modelVariant.dateModified" defaultMessage="Date modified" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="modelVariant.units" defaultMessage="Units" />
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <tr key={n.ModelVariantId} data-unittest="modelVariantData">
                <td>{n.Name || ''}</td>
                <td className="d-none d-md-table-cell">{n.Description || ''}</td>
                <td className="d-none d-md-table-cell">
                  {n.CreatedDateTime
                    ? moment
                      .unix(n.CreatedDateTime)
                      .tz(currentTimezone)
                      .format('DD-MMM-YYYY')
                    : '-'}
                </td>
                <td className="d-none d-md-table-cell">
                  {n.ModifiedDateTime
                    ? moment
                      .unix(n.ModifiedDateTime)
                      .tz(currentTimezone)
                      .format('DD-MMM-YYYY')
                    : '-'}
                </td>
                <td className="d-none d-md-table-cell">{n.NumberOfUnits || 0}</td>
                <td>
                  <MoreOption
                    dataArray={[
                      n.Owner && UpdateAllowed
                        ? {
                          Url: `/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variant/${n.ModelVariantId}`,
                          Name: <FormattedMessage id="modelVariant.edit" defaultMessage="EDIT" />
                        }
                        : {},
                      n.Owner && DuplicateAllowed
                        ? {
                          Url: `/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variant/${n.ModelVariantId}/true`,
                          Name: <FormattedMessage id="modelVariant.duplicate" defaultMessage="Duplicate" />
                        }
                        : {},
                      ConfigurationAllowed
                        ? {
                          Url: `/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variant-configuration/${n.ModelVariantId}`,
                          Name: <FormattedMessage id="modelVariant.configure" defaultMessage="Configure" />
                        }
                        : {}
                    ]}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};


ModelVariantListTable.propTypes = {
  currentTimezone: PropTypes.string.isRequired
};

export default injectIntl(ModelVariantListTable);
